module.exports = __webpack_public_path__ + "img/zhengshu1.ce3f17df.png";